var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9471 28.5521L56.3052 6.0545H51.718L34.9093 25.5888L21.4842 6.0545H6L26.3013 35.5938L6 59.186H10.5875L28.3379 38.5571L42.5158 59.186H58L36.9459 28.5521H36.9471ZM30.6638 35.8541L28.6069 32.9126L12.2405 9.5072H19.2866L32.4945 28.3961L34.5515 31.3376L51.7201 55.8903H44.674L30.6638 35.8552V35.8541Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.8b5103f1afc32e62d52101a717fa2b67.svg";
export { ForwardRef as ReactComponent };